"use strict";

import { notificationConstants, commonConstants } from "../_constants";

const INITIAL_NOTIFICATION_STATE = {
  unReadNotificationCount: 0,
  unReadSecureMailCount: 0,
  notificationList: [],
  notificationDetails: {
    data: [],
  },
  notificationListStatus: null,
  isPaginatingNotifications: false,
  isNotificationDetailError: false,
  notificationUpdate: {},
};

export function notification(state = INITIAL_NOTIFICATION_STATE, action) {
  switch (action.type) {
    case notificationConstants.NOTIFICATION_LIST_REQUEST:
      return {
        ...state,
        notificationList: [...state.notificationList],
        notificationUpdate: {},
      };
    case notificationConstants.NOTIFICATION_LIST_COMPLETE:
      return {
        ...state,

        notificationList: state.isPaginatingNotifications
          ? [
              ...state.notificationList,
              ...action?.payload?.data?.notificationList,
            ]
          : action?.payload?.data?.notificationList,
      };

    case notificationConstants.NOTIFICATION_LIST_ERROR:
      return {
        ...state,
        notificationList: [],
      };

    case notificationConstants.NOTIFICATION_LIST_CLEAR:
      return {
        ...state,
        notificationList: [],
      };

    case notificationConstants.NOTIFICATION_DETAIL_REQUEST:
      return {
        ...state,
        isNotificationDetailError: false,
        notificationDetails: {
          ...state.notificationDetails,
        },
      };

    case notificationConstants.NOTIFICATION_DETAIL_COMPLETE:
      return {
        ...state,
        notificationDetails: action?.payload?.data?.notificationDataDto,
      };

    case notificationConstants.NOTIFICATION_DETAIL_ERROR:
      return {
        ...state,
        isNotificationDetailError: true,
      };

    case notificationConstants.SET_NOTIFICATION_DETAIL_CLEAR:
      return {
        ...state,
        notificationDetails: {},
      };

    case notificationConstants.CLEAR_NOTIFICATION_DETAIL_ERROR:
      return {
        ...state,
        isNotificationDetailError: false,
      };

    case notificationConstants.NOTIFICATION_UPDATE_REQUEST:
      return {
        ...state,
        notificationUpdate: {},
      };

    case notificationConstants.NOTIFICATION_UPDATE_COMPLETE:
      return {
        ...state,
        notificationUpdate: {
          data: action.payload.data,
        },
      };

    case notificationConstants.NOTIFICATION_UPDATE_ERROR:
      return {
        ...state,
        notificationUpdate: {},
      };

    case notificationConstants.NOTIFICATION_UNREAD_COUNT_REQUEST:
      return {
        ...state,
        data: action.payload,
      };

    case notificationConstants.NOTIFICATION_UNREAD_COUNT_COMPLETE:
      return {
        ...state,
        unReadNotificationCount: action?.payload?.data?.unReadNotificationCount,
        unReadSecureMailCount: action?.payload?.data?.unReadSecureMailCount,
      };

    case notificationConstants.NOTIFICATION_UNREAD_COUNT_ERROR:
      return {
        ...state,
        unReadNotificationCount: 0,
        unReadSecureMailCount: 0,
      };

    case notificationConstants.SET_IS_PAGINATING_NOTIFICATIONS:
      return {
        ...state,
        isPaginatingNotifications: action.payload,
      };
  }

  return state;
}
